module.exports = __webpack_public_path__ + "img/user.c5dd188c.svg";